import actions from '../../actionTypes';

export default (email, siteId, orgId) => {
  return {
    type: actions.VIEW_LINK,
    email,
    siteId,
    orgId
  }
}


// WEBPACK FOOTER //
// ./src/reducers/users/actions/viewLink.js